import autobind from 'core-decorators/lib/autobind';

import { VODCSSModules } from 'shared/utils/wix-connect';

import styles from './icon.styl';
import fontelloIconsStyles from 'widget/player-widget/fontello/css/fontello-codes.css';


@VODCSSModules({ ...styles, ...fontelloIconsStyles })
export default class Icon extends React.Component {

  static propTypes = {
    onClick: React.PropTypes.func,
    name: React.PropTypes.string,
  };

  componentDidMount() {
    this.node.addEventListener('click', this.props.onClick);
  }

  componentWillUnmount() {
    this.node.removeEventListener('click', this.props.onClick);
  }

  @autobind
  setNodeRef(node) {
    this.node = node;
  }

  render() {
    const { name } = this.props;

    const props = _.omit(this.props, 'styles', 'styleName', 'name', 'intl', 'appSettings');

    return (
      <span styleName={`icon icon--${name}`}
            ref={this.setNodeRef}
            {...props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/icon/icon.js